import { retryingFetch } from '../retrying-fetch';

export interface AuthResponse {
  token: string;
  expiresAt: string;
  message?: string;
}

export class AuthService {
  public async acquireJWTToken(
    apiKey: string,
    loginUrl: string,
    shiroSessionId?: string,
    amAuthUserSessionId?: string
  ) {
    const url = new URL(loginUrl);
    url.searchParams.append('apiKey', apiKey);

    if (shiroSessionId) {
      url.searchParams.append('shiroSessionId', shiroSessionId);
    }
    if (amAuthUserSessionId) {
      url.searchParams.append('amAuthUserSessionId', amAuthUserSessionId);
    }
    if (!shiroSessionId && !amAuthUserSessionId) {
      url.searchParams.append('origin', window.location.host);
    }

    const response = await retryingFetch(url.toString());
    const authInfo = await response.json();

    return authInfo as AuthResponse;
  }
}

export const authSvc = new AuthService();
